<template>
    <section class="top-menu">
        <div>
            <b-nav tabs ref="topMenu">
                <b-nav-item :to="{name: 'competitors'}" :active="this.$router.currentRoute.name == 'competitors'">Добавить задание</b-nav-item>
                <b-nav-item :to="{name: 'competitorsTaskList'}" :active="this.$router.currentRoute.name == 'competitorsTaskList'">Активные задания</b-nav-item>
                <b-nav-item :to="{name: 'competitorsArchiveList'}" :active="this.$router.currentRoute.name == 'competitorsArchiveList'">Архивные задания</b-nav-item>
<!--                <b-nav-item :to="{name: 'competitorList'}" :active="this.$router.currentRoute.name == 'competitorList'">Исключенные сайты</b-nav-item>-->
            </b-nav>
        </div>
    </section>
</template>

<script>
    export default {
        name: "TopMenu"
    }
</script>

<style scoped>
    .top-menu {
        margin-bottom: 20px;
    }
</style>